import { generateAction as generate, reduxTypes as types } from 'ggtmo-utils';

// Action creators
import {
  EDITOR_TOGGLE_DELETE_CONFIRM_MODAL,
} from '../actionCreators/editorActionCreators';

// eslint-disable-next-line import/prefer-default-export
export const toggleDeleteConfirmModal = generate(EDITOR_TOGGLE_DELETE_CONFIRM_MODAL, { type: types.SYNC });
